import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowBack, SearchOutlined } from "@material-ui/icons";
import {
  FileDownloadSharp,
  GroupOutlined,
  SchoolOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exportToExcelJS } from "../helpers/ExcelJsHelper";
import { formatPhoneNumber, showMoneyFormat } from "../helpers/ExtraHelpers";
import { isTokenCreatedToday } from "../helpers/TokenHelpers";
import { useQuery } from "../hooks/useQuery";
import useToast from "../hooks/useToast";
import { historiqueService } from "../service/HistoriqueService";
import Menu from "./Menu";
import logo from "./logo.png";
import StandardSkeletoon from "./reusable/loader/StandardSkeletoon";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

export const EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS = [
  { field: "id_identite", headerName: "Id", width: 100 },
  { field: "full_name", headerName: "Nom et prénoms", width: 300 },
  { field: "reference", headerName: "Reference", width: 200 },
  { field: "adresse", headerName: "Adresse", width: 200 },
  { field: "district", headerName: "District", width: 200 },
  { field: "cin", headerName: "CIN", width: 200 },
  {
    field: "contact",
    headerName: "Contact",
    width: 200,
    valueFormatter: (params) => formatPhoneNumber(params),
  },
  {
    field: "whatsapp",
    headerName: "Whatsapp",
    width: 150,
    valueFormatter: (params) => formatPhoneNumber(params),
  },
  { field: "facebook", headerName: "Facebook", width: 200 },
  { field: "email", headerName: "Email", width: 200 },
  {
    field: "num_carte_fiscal",
    headerName: "NIF",
    width: 200,
    valueFormatter: (params) => (params === "null" ? "" : params),
  },
  {
    field: "numero_carte_stat",
    headerName: "STAT",
    width: 200,
    valueFormatter: (params) => (params === "null" ? "" : params),
  },
  { field: "libelle_type", headerName: "Poste postulé", width: 200 },
  { field: "Date_creation", headerName: "Postulé le", width: 200 },
  { field: "diplome", headerName: "Diplômes", width: 400 },
  { field: "experience", headerName: "Experiences", width: 400 },
  { field: "formation", headerName: "Formations", width: 400 },
  {
    field: "pretention_salariale",
    headerName: "Prétention salariale",
    width: 200,
    valueFormatter: (params) => (params ? showMoneyFormat(params, "MGA") : ""),
  },
  { field: "localisation", headerName: "Localisations", width: 300 },
  { field: "state", headerName: "Statut dossier", width: 150 },
  { field: "link", headerName: "Link", width: 400 },
];

const ListCandidat = ({ prec_url }) => {
  const { Toast, showToast } = useToast();
  const [idsButons, setIdsButons] = useState([]);
  const [rows, setRows] = useState([]);
  const [filtre, setFiltre] = useState({ mot: "", status: "complet" });
  const [rowsData, setRowsData] = useState([]);
  const [loadingDonwDocs, setLoadingDonwDocs] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [colonne, setColonne] = useState([
    ...EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS,
    {
      field: "Actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Grid display="flex" gap={1} alignItems="center">
          <Grid item>
            <LoadingButton
              variant="contained"
              size="small"
              sx={{
                minWidth: "40px",
                borderRadius: "8px",
                p: 0.5,
                boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
              }}
              loading={idsButons.includes(params.row.id_identite)}
              color="success"
              title={`Telecharger tous les documents envoyés par ${params.row.full_name}`}
              onClick={(e) => handleDownloadZip(params.row)}
            >
              <FileDownloadSharp fontSize="small" />
            </LoadingButton>
          </Grid>
        </Grid>
      ),
    },
  ]);
  const query = useQuery();
  const navigate = useNavigate();

  const handleDownloadExcel = () => {
    if (rows.length > 0) {
      /* exportToExcel(
        rows,
        EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS,
        rows.at(0).libelle_type || "Liste des candidats",
        false,
      ); */
      exportToExcelJS(
        rows,
        colonne,
        rows.at(0).libelle_type || "Liste des candidats",
        false
      );
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Erreur de l'exportation de données excel",
      );
    }
  };

  const handleDownloadAllFiles = (
    id_position,
    file_name = "Documents envoyés",
    state = "complet",
  ) => {
    setLoadingDonwDocs(true);
    if (query.get("id_type")) {
      handleLoadThisButton(id_position);
      historiqueService
        .downloadAllDocByIdPosition(id_position, filtre.status)
        .then((response) => {
          if (response.status !== 200) {
            showToast(TYPE_NOTIFICATION.ERROR, "Echec de telechargement");
            handleLoadThisButton(false);
            return;
          }
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${file_name || "Document de tous les candidats"} .zip`,
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          showToast(TYPE_NOTIFICATION.ERROR, e.tosTring());
        })
        .finally(() => {
          handleUnloadThisButton(id_position);
          setLoadingDonwDocs(false);
        });
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Erreur de telechargement");
    }
  };

  const handleDownloadZip = (row) => {
    handleLoadThisButton(row.id_identite);
    showToast(TYPE_NOTIFICATION.INFO, "Chargement des données à compresser...");
    historiqueService
      .downloadUploadedFiles(row)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Document de " + row.full_name + ".zip");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
      })
      .finally(() => {
        handleUnloadThisButton(row.id_identite);
      });
  };

  useEffect(() => {
    let token = query.get("ref");
    if (isTokenCreatedToday(token)) {
      localStorage.setItem("CODE_ADMIN", token);
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Token non fourni ou invalide");
      navigate("/");
    }
    /*  if (query.get("id_type")) {
      handleFetchCandidatList(query.get("id_type"));
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Offre d'emploi non identifié");
    } */
    let col_with_action = colonne;

    setColonne(col_with_action);
  }, []);

  const handleFilter = (filtre) => {
    if (!filtre || (!filtre.mot && !filtre.status)) {
      setRowsData(rows);
      return;
    }

    const mots = filtre.mot
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");

    setRowsData(
      rows.filter((item) =>
        // Vérifie le status si filtre.status est défini
        //(!filtre.status || item.state === filtre.status) &&
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const handleLoadThisButton = (ids) => {
    setIdsButons([...idsButons, ids]);
  };

  const handleUnloadThisButton = (ids) => {
    setIdsButons(idsButons.filter((id) => id !== ids));
  };

  const handleFetchCandidatList = (id_type, state = "complet") => {
    setLoadingData(true);
    historiqueService
      .getListeCandidat(id_type, state)
      .then((res) => {
        if (res && res.data) {
          setRows(res.data);
          setRowsData(res.data);
        }
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  useEffect(() => {
    if (filtre.status || query.get("id_type")) {
      handleFetchCandidatList(query.get("id_type"), filtre.status);
    }
  }, [filtre.status, query.get("id_type")]);

  useEffect(() => {
    if (filtre) {
      handleFilter(filtre);
    }
  }, [filtre]);

  return (
    <Grid
      container
      sx={{
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Menu />
      <Grid
        item
        xs={12}
        md={11}
        lg={10}
        xl={9}
        sx={{
          minHeight: "90vh",
          backgroundColor: "#ffffff",
          borderRadius: "24px",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.08)",
          display: "flex",
          flexDirection: "column",
          p: { xs: 2, md: 4 },
          mt: 4,
          mb: 4,
          overflow: "hidden",
        }}
      >
        <Grid
          container
          alignItems={"center"}
          justifyContent={"space-between"}
          mb={4}
        >
          <Grid item>
            <Button
              color="primary"
              title="Retour à la liste des offres externes"
              onClick={(e) =>
                navigate(`/administrations?ref=${query.get("ref")}`)
              }
              startIcon={<ArrowBack />}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "12px",
                px: 2,
                py: 1,
                "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.08)" },
              }}
            >
              <Typography variant="body1" display={{ xs: "none", md: "flex" }}>
                Retour
              </Typography>
            </Button>
          </Grid>
          <Grid
            item
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            flexGrow={1}
          >
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                maxWidth: "60px",
                maxHeight: "60px",
                marginBottom: "8px",
              }}
            />
            <Typography
              variant="h4"
              fontWeight={700}
              color="primary.main"
              sx={{ letterSpacing: "-0.5px" }}
            >
              Liste des candidats
            </Typography>
          </Grid>
          <Grid item width={"80px"}></Grid> {/* Spacer for centering */}
        </Grid>

        <Toast />

        <Box
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 3 }}
        >
          {/* KPI Cards */}
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "20px",
                  background:
                    "linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)",
                  boxShadow: "0 4px 20px rgba(0,188,212,0.15)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "translateY(-5px)" },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#00bcd4",
                    color: "white",
                    p: 1.5,
                    borderRadius: "14px",
                    display: "flex",
                  }}
                >
                  <GroupOutlined fontSize="large" />
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight={600}
                    textTransform="uppercase"
                  >
                    Effectif des postulants
                  </Typography>
                  <Typography variant="h3" color="#00838f" fontWeight={800}>
                    {rowsData.length}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "20px",
                  background:
                    "linear-gradient(135deg, #ede7f6 0%, #d1c4e9 100%)",
                  boxShadow: "0 4px 20px rgba(103,58,183,0.15)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "translateY(-5px)" },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#673ab7",
                    color: "white",
                    p: 1.5,
                    borderRadius: "14px",
                    display: "flex",
                  }}
                >
                  <SchoolOutlined fontSize="large" />
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight={600}
                    textTransform="uppercase"
                  >
                    Niveau universitaire
                  </Typography>
                  <Typography variant="h3" color="#4527a0" fontWeight={800}>
                    {
                      rowsData.filter((item) => {
                        const diplome = (item.diplome || "").toLowerCase();
                        return [
                          "licence",
                          "master",
                          "dea",
                          "aea",
                          "doctorat",
                          "maitrise",
                          "bacc+",
                        ].some((d) => diplome.includes(d.toLowerCase()));
                      }).length
                    }
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>

          {/* Filters and Actions */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "16px",
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              alignItems: "center",
            }}
          >
            <Box sx={{ flexGrow: 1, minWidth: "250px" }}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                onChange={(e) => setFiltre({ ...filtre, mot: e.target.value })}
                placeholder="Rechercher un candidat, compétence, etc."
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchOutlined color="action" />
                      </InputAdornment>
                    ),
                    sx: { borderRadius: "12px", backgroundColor: "white" },
                  },
                }}
              />
            </Box>
            <Autocomplete
              size="small"
              disablePortal
              options={["complet", "incomplet"]}
              onChange={(e, val) => setFiltre({ ...filtre, status: val })}
              sx={{
                width: 180,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "white",
                },
              }}
              value={filtre.status}
              renderInput={(params) => <TextField {...params} label="Statut" />}
            />
            <Button
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
                py: 1,
              }}
              onClick={(e) => handleDownloadExcel()}
              startIcon={<FontAwesomeIcon icon={faFileExcel} size="xl" />}
            >
              <Typography variant="body2" display={{ xs: "none", md: "block" }}>
                Excel export
              </Typography>
            </Button>
            <LoadingButton
              loading={loadingDonwDocs}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
                py: 1,
                boxShadow: "0 4px 14px 0 rgba(0,118,255,0.39)",
              }}
              onClick={(e) =>
                handleDownloadAllFiles(
                  query.get("id_type"),
                  rows.at(0)?.libelle_type || "Tous les documents envoyés",
                )
              }
              startIcon={<FileDownloadSharp />}
            >
              <Typography variant="body2" display={{ xs: "none", md: "block" }}>
                Tous les documents
              </Typography>
            </LoadingButton>
          </Paper>

          {/* DataGrid */}
          <Box
            sx={{
              flexGrow: 1,
              minHeight: "400px",
              height: "60vh",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              overflow: "hidden",
              border: "1px solid #e2e8f0",
            }}
          >
            <StandardSkeletoon col={3} row={8} show={loadingData} />
            <DataGrid
              columns={colonne.filter(
                (item) =>
                  !["pretention_salariale", "link", "id_identite"].includes(
                    item.field,
                  ),
              )}
              rows={rowsData}
              getRowId={(row) => row.id_identite}
              localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              sx={{
                display: loadingData ? "none" : "flex",
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8fafc",
                  color: "#334155",
                  fontWeight: 700,
                  fontSize: "14px",
                  borderBottom: "2px solid #e2e8f0",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f1f5f9",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f8fafc",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1px solid #e2e8f0",
                },
              }}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ListCandidat;
